import { ComponentDesign, ComponentDesignLayoutModel, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { AnalogModelSchema } from './AnalogModelSchema';
import { ComponentSchema } from './ComponentSchema';
import { LoadCaseSchema } from './LoadCaseSchema';

export const ComponentDesignSchema = new ModelSchema<ComponentDesign>('componentDesign', {
  category: ModelCategory.ComponentDesign,

  properties: {},

  children: {
    analogModel: AnalogModelSchema,
    component: ComponentSchema,
    loadCases: LoadCaseSchema,
  },

  // For historical reasons in project client, we have to accept layout models here as well.
  displayName: (componentDesign: ComponentDesign | ComponentDesignLayoutModel) =>
    'component' in componentDesign ? componentDesign.component.name : componentDesign.name,
});
